// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tables-chooser-container {
    z-index: 10000;
    position: absolute;
    top: 0;
    right: 0;
    width: 100vw;
    height: 100vh;
    background-color: white;
}

.table-option-card {
    max-width: 100px;
    border: 1px solid #edebe9;
    font-size: 10px;
    position: relative;
}

.table-option-card:hover {
    box-shadow:
        0px 1.2px 3.6px rgba(0, 0, 0, 0.1),
        0px 6.4px 14.4px rgba(0, 0, 0, 0.13);
}

.chart-chooser-container {
    z-index: 10000;
    position: absolute;
    top: 0;
    right: 0;
    width: 100vw;
    height: 100vh;
    background-color: white;
}

.logo-img {
    width: 24px;
    height: 24px;
}

.logo-text {
    font-family: Calibri, helvetica, sans-serif;
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    line-height: 22px;
}

.logo-text .fw-400 {
    font-weight: 400;
}

.dimension-item {
    padding: 8px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    min-width: 150px;
}

.dimension-item h1 {
    padding-left: 6px;
}

.active-card {
    background: #edebe9;
}

.active-blue-line {
    position: absolute;
    left: 0;
    height: 50%;
    width: 3px;
    border-radius: 500px;
    background: #0078d4;
}

.chart-option-card {
    border: 1px solid #edebe9;
    font-size: 10px;
}

.chart-option-card:hover {
    box-shadow:
        0px 1.2px 3.6px rgba(0, 0, 0, 0.1),
        0px 6.4px 14.4px rgba(0, 0, 0, 0.13);
}

.table-tooltip {
    background: #303231;
    opacity: 0.95;
    border-radius: 2px !important;
    color: white;
    max-width: 200px;
    padding: 12px;
    z-index: 9999;
}

.active-chart-card {
    border: 2px solid #0078d4;
}

.settings-container {
    width: 400px;
    height: 100%;
    background: #f8f8fa;
    border-left: 2px solid #edebe9;
    padding: 24px 10px;
}

.setting {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.setting h1 {
    margin-left: 10px;
    font-weight: 600;
    font-size: 12px;
    line-height: 16px;
    cursor: pointer;
    -webkit-user-select: none;
    -moz-user-select: none;
         user-select: none;
}

.settings-options {
    width: 100%;
    height: 300px;
    background: #ffffff;
    border-radius: 2px;
    margin: 10px 0px;
}

.zebrabi-switch {
    height: 18px;
    border-radius: 500px;
    background: #0078d4;
    border: 1px solid #0078d4;
    color: white;
    display: flex;
    justify-content: space-evenly;
    align-items: center;
    padding: 4px;
    cursor: pointer;
    font-size: 10px;
    transition: all 0.5s;
}

.off {
    background: none;
    color: #605e5c;
    border: 1px solid #605e5c;
    flex-direction: row-reverse;
}

.zebrabi-switch .circle {
    height: 100%;
    aspect-ratio: 1/1;
    border-radius: 50%;
    background: #ffffff;
    margin: 0px 2px;
}

.off .circle {
    background: #605e5c;
}

.chart-chooser-main {
    overflow-y: scroll;
}

.chart-chooser-main::-webkit-scrollbar {
    width: 4px;
}

.help-link-container {
    width: 100%;
    height: 50px;
    position: absolute;
    bottom: 0px;
    display: flex;
    align-items: center;
    border-top: 1px solid rgb(209 213 219);
}

.help-link {
    font-size: 12px;
    margin-left: 22px;
    cursor: pointer;
    color: #0078d4;
    border: none;
}

.templates {
    border-top: 1px solid #edebe9;
    padding-top: 20px;
    margin-top: 20px;
}

.template-option-card {
    border: 1px solid #edebe9;
    font-size: 10px;
}

.template-option-card:hover {
    box-shadow:
        0px 1.2px 3.6px rgba(0, 0, 0, 0.1),
        0px 6.4px 14.4px rgba(0, 0, 0, 0.13);
}

.border-r-gray {
    border-right: 1px solid rgb(209 213 219);
}

.border-b-gray {
    border-bottom: 1px solid rgb(209 213 219);
}

h1.new-badge {
    color: #0078d4;
    background-color: #deecf9;
    border: 1px solid #0078d4;
    padding: 0px 2px;
    margin-left: 4px;
    border-radius: 4px;
}

.option-new-badge {
    position: absolute;
    right: -8px;
    top: -9px;
}
`, "",{"version":3,"sources":["webpack://./packages/tables-chooser/react/screen/TablesChooserScreen/index.css"],"names":[],"mappings":"AAAA;IACI,cAAc;IACd,kBAAkB;IAClB,MAAM;IACN,QAAQ;IACR,YAAY;IACZ,aAAa;IACb,uBAAuB;AAC3B;;AAEA;IACI,gBAAgB;IAChB,yBAAyB;IACzB,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI;;4CAEwC;AAC5C;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,MAAM;IACN,QAAQ;IACR,YAAY;IACZ,aAAa;IACb,uBAAuB;AAC3B;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,2CAA2C;IAC3C,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,2BAA2B;IAC3B,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,OAAO;IACP,WAAW;IACX,UAAU;IACV,oBAAoB;IACpB,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;IACzB,eAAe;AACnB;;AAEA;IACI;;4CAEwC;AAC5C;;AAEA;IACI,mBAAmB;IACnB,aAAa;IACb,6BAA6B;IAC7B,YAAY;IACZ,gBAAgB;IAChB,aAAa;IACb,aAAa;AACjB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,mBAAmB;IACnB,8BAA8B;IAC9B,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,eAAe;IACf,yBAAyB;IACzB,sBAAiB;SAAjB,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,oBAAoB;IACpB,mBAAmB;IACnB,yBAAyB;IACzB,YAAY;IACZ,aAAa;IACb,6BAA6B;IAC7B,mBAAmB;IACnB,YAAY;IACZ,eAAe;IACf,eAAe;IACf,oBAAoB;AACxB;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,yBAAyB;IACzB,2BAA2B;AAC/B;;AAEA;IACI,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,sCAAsC;AAC1C;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,eAAe;IACf,cAAc;IACd,YAAY;AAChB;;AAEA;IACI,6BAA6B;IAC7B,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;IACzB,eAAe;AACnB;;AAEA;IACI;;4CAEwC;AAC5C;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;IACI,yCAAyC;AAC7C;;AAEA;IACI,cAAc;IACd,yBAAyB;IACzB,yBAAyB;IACzB,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,SAAS;AACb","sourcesContent":[".tables-chooser-container {\n    z-index: 10000;\n    position: absolute;\n    top: 0;\n    right: 0;\n    width: 100vw;\n    height: 100vh;\n    background-color: white;\n}\n\n.table-option-card {\n    max-width: 100px;\n    border: 1px solid #edebe9;\n    font-size: 10px;\n    position: relative;\n}\n\n.table-option-card:hover {\n    box-shadow:\n        0px 1.2px 3.6px rgba(0, 0, 0, 0.1),\n        0px 6.4px 14.4px rgba(0, 0, 0, 0.13);\n}\n\n.chart-chooser-container {\n    z-index: 10000;\n    position: absolute;\n    top: 0;\n    right: 0;\n    width: 100vw;\n    height: 100vh;\n    background-color: white;\n}\n\n.logo-img {\n    width: 24px;\n    height: 24px;\n}\n\n.logo-text {\n    font-family: Calibri, helvetica, sans-serif;\n    font-style: normal;\n    font-weight: 600;\n    font-size: 16px;\n    line-height: 22px;\n}\n\n.logo-text .fw-400 {\n    font-weight: 400;\n}\n\n.dimension-item {\n    padding: 8px;\n    display: flex;\n    justify-content: flex-start;\n    align-items: center;\n    min-width: 150px;\n}\n\n.dimension-item h1 {\n    padding-left: 6px;\n}\n\n.active-card {\n    background: #edebe9;\n}\n\n.active-blue-line {\n    position: absolute;\n    left: 0;\n    height: 50%;\n    width: 3px;\n    border-radius: 500px;\n    background: #0078d4;\n}\n\n.chart-option-card {\n    border: 1px solid #edebe9;\n    font-size: 10px;\n}\n\n.chart-option-card:hover {\n    box-shadow:\n        0px 1.2px 3.6px rgba(0, 0, 0, 0.1),\n        0px 6.4px 14.4px rgba(0, 0, 0, 0.13);\n}\n\n.table-tooltip {\n    background: #303231;\n    opacity: 0.95;\n    border-radius: 2px !important;\n    color: white;\n    max-width: 200px;\n    padding: 12px;\n    z-index: 9999;\n}\n\n.active-chart-card {\n    border: 2px solid #0078d4;\n}\n\n.settings-container {\n    width: 400px;\n    height: 100%;\n    background: #f8f8fa;\n    border-left: 2px solid #edebe9;\n    padding: 24px 10px;\n}\n\n.setting {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n}\n\n.setting h1 {\n    margin-left: 10px;\n    font-weight: 600;\n    font-size: 12px;\n    line-height: 16px;\n    cursor: pointer;\n    -webkit-user-select: none;\n    user-select: none;\n}\n\n.settings-options {\n    width: 100%;\n    height: 300px;\n    background: #ffffff;\n    border-radius: 2px;\n    margin: 10px 0px;\n}\n\n.zebrabi-switch {\n    height: 18px;\n    border-radius: 500px;\n    background: #0078d4;\n    border: 1px solid #0078d4;\n    color: white;\n    display: flex;\n    justify-content: space-evenly;\n    align-items: center;\n    padding: 4px;\n    cursor: pointer;\n    font-size: 10px;\n    transition: all 0.5s;\n}\n\n.off {\n    background: none;\n    color: #605e5c;\n    border: 1px solid #605e5c;\n    flex-direction: row-reverse;\n}\n\n.zebrabi-switch .circle {\n    height: 100%;\n    aspect-ratio: 1/1;\n    border-radius: 50%;\n    background: #ffffff;\n    margin: 0px 2px;\n}\n\n.off .circle {\n    background: #605e5c;\n}\n\n.chart-chooser-main {\n    overflow-y: scroll;\n}\n\n.chart-chooser-main::-webkit-scrollbar {\n    width: 4px;\n}\n\n.help-link-container {\n    width: 100%;\n    height: 50px;\n    position: absolute;\n    bottom: 0px;\n    display: flex;\n    align-items: center;\n    border-top: 1px solid rgb(209 213 219);\n}\n\n.help-link {\n    font-size: 12px;\n    margin-left: 22px;\n    cursor: pointer;\n    color: #0078d4;\n    border: none;\n}\n\n.templates {\n    border-top: 1px solid #edebe9;\n    padding-top: 20px;\n    margin-top: 20px;\n}\n\n.template-option-card {\n    border: 1px solid #edebe9;\n    font-size: 10px;\n}\n\n.template-option-card:hover {\n    box-shadow:\n        0px 1.2px 3.6px rgba(0, 0, 0, 0.1),\n        0px 6.4px 14.4px rgba(0, 0, 0, 0.13);\n}\n\n.border-r-gray {\n    border-right: 1px solid rgb(209 213 219);\n}\n\n.border-b-gray {\n    border-bottom: 1px solid rgb(209 213 219);\n}\n\nh1.new-badge {\n    color: #0078d4;\n    background-color: #deecf9;\n    border: 1px solid #0078d4;\n    padding: 0px 2px;\n    margin-left: 4px;\n    border-radius: 4px;\n}\n\n.option-new-badge {\n    position: absolute;\n    right: -8px;\n    top: -9px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
